import React from "react";
import Body from "lib/preferences/Body";
import userStore from "data/userStore";
import asModal from "lib/modal/asModal";
import Dispatcher from "Dispatcher";
import UserActions from "data/UserActions";
import useFluxStore from "@armus/use-flux-store";

export const BackbonePreferencesModule = asModal({
    title: "User Preferences",
    size: "md"
})(() => {
    const state = useFluxStore(() => ({
        defaultSearch: userStore.getDefaultSearchConfig(),
        updateDefaultSearchEnablement: enabled => Dispatcher.dispatch({
            type: UserActions.UPDATE_ORG_USER_PREFERENCE,
            pref: "use-default-search",
            value: !!enabled,
        }),
    }), [
        userStore,
    ]);
    return <Body {...state} />;
});



// WEBPACK FOOTER //
// ./app/lib/preferences/PreferencesModule.js